import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ArcoVue from "@arco-design/web-vue";
import "@arco-design/web-vue/dist/arco.css";
import "@/utils/index.less";
import ArcoVueIcon from "@arco-design/web-vue/es/icon";
// import axios from 'axios'
import "@/assets/font/index.css"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App)
    .use(ElementPlus)
    .use(ArcoVue)
    .use(ArcoVueIcon)
    .use(store)
    .use(router)
    .mount("#app");
